import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AppProvider } from "@/context/AppContext";
import LandingPage from "@/pages/LandingPage";
import CountrySelection from "@/pages/CountrySelection";
import DocumentRequirements from "@/pages/DocumentRequirements";
import UploadPage from "@/pages/UploadPage";
import BundleUploadPage from "@/pages/BundleUploadPage";
import ProcessingPage from "@/pages/ProcessingPage";
import BundleProcessingPage from "@/pages/BundleProcessingPage";
import ResultsPage from "@/pages/ResultsPage";
import BundleResultsPage from "@/pages/BundleResultsPage";
import PaymentSuccessPage from "@/pages/PaymentSuccessPage";
import PaymentCheckoutPage from "@/pages/PaymentCheckoutPage";
import BatchResultsPage from "@/pages/BatchResultsPage";
import AuthCallback from "@/pages/AuthCallback";
import Dashboard from "@/pages/Dashboard";
import HistoryPage from "@/pages/HistoryPage";
import AnalyticsDashboard from "@/pages/AnalyticsDashboard";

// Router component that handles OAuth callback detection
function AppRouter() {
  const location = useLocation();
  
  // Check URL fragment for session_id (OAuth callback)
  // This must happen synchronously during render, not in useEffect
  if (location.hash?.includes('session_id=')) {
    return <AuthCallback />;
  }
  
  return (
    <Routes>
      <Route path="/" element={<LandingPage />} />
      <Route path="/select-country" element={<CountrySelection />} />
      <Route path="/documents" element={<DocumentRequirements />} />
      <Route path="/upload" element={<UploadPage />} />
      <Route path="/bundle-upload" element={<BundleUploadPage />} />
      <Route path="/processing" element={<ProcessingPage />} />
      <Route path="/bundle-processing" element={<BundleProcessingPage />} />
      <Route path="/results" element={<ResultsPage />} />
      <Route path="/bundle-results" element={<BundleResultsPage />} />
      <Route path="/payment-success" element={<PaymentSuccessPage />} />
      <Route path="/payment-checkout" element={<PaymentCheckoutPage />} />
      <Route path="/batch-results" element={<BatchResultsPage />} />
      <Route path="/auth/callback" element={<AuthCallback />} />
      <Route path="/dashboard" element={<Dashboard />} />
      <Route path="/history" element={<HistoryPage />} />
      <Route path="/analytics" element={<AnalyticsDashboard />} />
    </Routes>
  );
}

function App() {
  return (
    <AppProvider>
      <div className="App">
        <BrowserRouter>
          <AppRouter />
        </BrowserRouter>
        <Toaster />
      </div>
    </AppProvider>
  );
}

export default App;
